import React, { useContext, useEffect, useState } from "react";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";
import { appContext } from "../../AarmaContext";
import axios from "axios";
import Pagination from "../../Common/Pagination";
import Statustics from "./Statustics";

function Dashboard() {
  const { account, settings, copyaddress, formatAddress } = useContext(appContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);


  const getData = async () => {
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "transaction",
        submethod: "getbyid",
        address: account,
        page: currentPage,
        pageSize: pageSize,
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        // var dedata = decryptData(res.data);
        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.dataLength / pageSize));

      });
  };

  useEffect(() => {
    getData();
  }, [account, pages, pageSize, currentPage]);
  return (
    <>
      <Header />
      <section className="discover_web3 pools_tables pt-120 pb-120 earn_crypto">
        <Statustics />
        <h1 className="d-flex justify-content-center">Presale Dashboard</h1>
        <div className="container d-flex align-items-center pt-5">
          <div className="col-12 pt-5">
            <div className="apex_section__tablearea br2 rounded-20 bg1-color overflow-auto mt-5 mt-md-6">
              <div className="apex_section__tablechart p-5 p-md-6 d-flex gap-4 align-items-center justify-content-between bg_blur">
                <table>
                  <tbody>
                    <tr className="text-center ">
                      <th className="fs-ten">#</th>
                      <th className="fs-ten">Type</th>
                      <th className="fs-ten">BNB #</th>
                      <th className="fs-ten">ARMA #</th>
                      <th className="fs-ten">USDT</th>
                      <th className="fs-ten">ARMA</th>
                      <th className="fs-ten">ARMA(Coin)</th>
                      <th className="fs-ten">Rate</th>
                      <th className="fs-ten">Datetime</th>
                      <th className="fs-ten">Status</th>
                    </tr>
                    {data.map((item, index) => {
                      return (
                        <tr className="text-center tablehover">
                          <td>{item.id}</td>
                          <td>  <img
                            className="border-0"
                            src={`/assets/images/${item.isarma ? "aarma" : "usdt"}.png`}
                            width={20}
                            alt="loading"
                          /></td>
                          <td>{formatAddress(item.bsc_hash)}</td>
                          <td>{formatAddress(item.arma_hash)}</td>
                          <td> {item.isarma ? '-' : `$ ${Number(item.amount).toFixed(4)}`}</td>
                          <td> {item.isarma ? `${Number(item.arma).toFixed(4)} ARMA` : '-'}</td>
                          <td> {Number(item.arma_new)} ARMA</td>
                          <td>$ {Number(item.rate).toFixed(4)}</td>
                          <td>
                            {item.createdAt}
                          </td>
                          <td className="d-flex align-items-center justify-content-center gap-3">
                            {item.status === false ?
                              <button className="roboto fw-bold px-3 px-md-4 py-1 rounded-1 addbtn">
                                Pending
                              </button> :
                              <button className="roboto fw-bold px-3 py-1 rounded-1 bg9-color p4-color">
                                Success
                              </button>}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              pages={pages}
            />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Dashboard;
